(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendation-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mascolori-recommendations')) {
    customElements.define('mascolori-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true' || this.hasAttribute('data-requested')) return;
        this.setAttribute('data-requested', '');
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.observer.disconnect();
              this.loadRecommendations();
            }
          }, {rootMargin: '500px'});
          this.observer.observe(this);
        } else {
          this.loadRecommendations();
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        clearTimeout(this.timeout);
        if (this.dataset.ready !== 'true') this.removeAttribute('data-requested');
      }
      async loadRecommendations() {
        this.controller = new AbortController();
        this.timeout = setTimeout(() => this.controller.abort(), 10000);
        try {
          const url = new URL(this.dataset.url, window.location.origin);
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, {signal: this.controller.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Recommendations unavailable');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = documentFragment.querySelector('[data-mc-related-content]');
          if (!this.isConnected) return;
          if (content?.querySelector('.mc-related__item')) {
            this.replaceChildren(content);
            this.hidden = false;
            this.dataset.ready = 'true';
          } else {
            this.hidden = true;
          }
        } catch (_) {
          if (this.isConnected) this.hidden = true;
        } finally {
          clearTimeout(this.timeout);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-title"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    root.querySelectorAll('[data-mc-title-words]').forEach(track => {
      if (track.dataset.mcTitleReady) return;
      track.dataset.mcTitleReady = 'true';
      const words = Array.from(track.children);
      if (words.length < 2) return;
      let index = 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const render = () => {
        track.style.transform = 'translateY(-' + words[index].offsetTop + 'px)';
      };
      const observer = new ResizeObserver(() => {
        track.style.transition = 'none';
        render();
      });
      observer.observe(track.parentElement);
      const timer = window.setInterval(() => {
        if (!track.isConnected) {
          window.clearInterval(timer);
          observer.disconnect();
          return;
        }
        if (document.hidden || reducedMotion.matches) return;
        index = (index + 1) % words.length;
        track.style.transition = 'transform 350ms ease';
        render();
      }, 3000);
      render();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
